import { TUser, getTeams, Loading, Team, Section, Heading } from '@sifrovacihra/shared-ui';
import { useEffect, useState } from 'react';



export const Teams = () => {
    const [teams, setTeams] = useState<TUser[]>([])
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        setLoading(true)
        getTeams().then(r => {
            console.log(r)
            if (r.teams) {
                setTeams(r.teams)
            }
        }).finally(() => {
            setLoading(false)
        })
    }, [])

    return (
        <>
            <Heading
                headline="Přihlášené týmy"
                weight={1}
            />

            <Section>
                <p>V kategorii Začátečníci je přihlášeno celkem: {teams.filter(t => t.Cathegory === 'Z').length} týmů.</p>
            </Section>
            <Section>
                <>
                    {loading ? <Loading/> : '' }
                    {teams.filter(t => t.Cathegory === 'Z').map(t => { return <Team team={t} admin={false}></Team> })}
                </>
            </Section>
            <Section>
                <p>V kategorii Pokročilí je přihlášeno celkem: {teams.filter(t => t.Cathegory === 'P').length} týmů.</p>
            </Section>
            <Section>
                <>
                    {loading ? <Loading /> : ''}
                    {teams.filter(t => t.Cathegory === 'P').map(t => { return <Team team={t} admin={false}></Team> })}
                </>
            </Section>
        </>
    )
}
